import { ReactNode } from "react";
import { Heading } from "src/api/sure-api/ssq/useGetOneSsq";
import { QuestionnairesList } from "src/components/QuestionnairesList/QuestionnairesList";
import { ANSWER_SSQ, PRODUCT, useFoodpilotContext } from "src/context/FoodpilotContext";
import { URLHandler } from "src/services/URLHandler";
import { useGetProductPost } from "src/api/client-api/post/useGetProductPost";
import { useProductContext } from "../ProductContext";
import { ScoreChart, ScoreChartValues } from "src/components/ScoreChart/ScoreChart";

export const Questionnaire = (): ReactNode => {
    const {
        product,
        ssq,
        isSsqLoading,
        selectedScore,
        allScoreWithVariations,
        isLoading,
        productDetailBuilder,
        isRefetching,
    } = useProductContext();
    const { selectedCompany, currentCampaign, canUser } = useFoodpilotContext();
    const companyId = selectedCompany ? selectedCompany.id : null;
    const { post, isLoading: isPostLoading } = useGetProductPost(product?.id, companyId, currentCampaign?.id);

    if (!product) return null;
    if (selectedCompany === null) return null;

    const headings = productDetailBuilder.getByHeadings();
    if (headings === null) return null;

    const acc: ScoreChartValues = { labels: [], values: [] };
    const chartValues = headings.headings.reduce((prevAcc, heading) => {
        prevAcc.labels.push(heading.title);
        prevAcc.values.push(heading.score.value ?? 0);
        return prevAcc;
    }, acc);

    return (
        <>
            <QuestionnairesList
                ssq={ssq}
                post={post}
                isSsqLoading={isSsqLoading}
                isPostLoading={isPostLoading}
                displayDateLastModified={false}
                completeQuestionnaireUrl={(heading: Heading) => {
                    const url = URLHandler.product.ssqHeading(selectedCompany.id, product.id, heading.id);
                    return url;
                }}
                scoresSection={
                    <ScoreChart
                        allScoreWithVariations={allScoreWithVariations}
                        selectedScore={selectedScore}
                        totalScore={headings.total.value}
                        data={chartValues}
                        isLoading={isLoading}
                        isRefetching={isRefetching}
                    />
                }
                enableTableHead={false}
                muiTableProps={{
                    sx: {
                        border: "none",
                    },
                }}
                tableMode="extended"
                canEdit={canUser(ANSWER_SSQ, PRODUCT)}
            />
        </>
    );
};
